function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWhiteboard = function SvgWhiteboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.987 1.517H3.517v9.446h16.47ZM3.517.167c-.758 0-1.372.605-1.372 1.35v9.446c0 .745.614 1.349 1.372 1.349h16.47c.758 0 1.373-.604 1.373-1.35V1.518c0-.745-.615-1.35-1.373-1.35z",
    style: {
      strokeWidth: 0.907266
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.286 11.02a.67.67 0 0 1 .348.891L6.89 17.984a.691.691 0 0 1-.906.342.67.67 0 0 1-.348-.89l2.745-6.073a.691.691 0 0 1 .906-.342zM14.218 11.02a.67.67 0 0 0-.348.891l2.745 6.073c.154.34.56.494.906.342a.67.67 0 0 0 .348-.89l-2.745-6.073a.691.691 0 0 0-.906-.342z",
    style: {
      strokeWidth: 0.907266
    }
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: 6,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      InkscapeFontSpecification: "'sans-serif, Bold'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal"
    },
    x: -0.041,
    y: 23.994
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -0.041,
    y: 23.994,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: 6,
      fontFamily: "sans-serif",
      InkscapeFontSpecification: "'sans-serif, Bold'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal"
    }
  }, "BOARD")));
};
export default SvgWhiteboard;